import { Logger } from 'innovatint_base/common/Logger';

declare global {
  interface Window {
    qtside?: {
      bridge?: {
        logMessage?: (level: number, message: string) => void;
        [key: string]: unknown;
      };
      [key: string]: unknown;
    };
  }
}

const log = new Logger((level, message) =>
  window.qtside?.bridge?.logMessage?.(level, message)
);

export default log;
